/* Open the header's dropdown menus on hover.

   snippets/header-dropdown-menu.liquid builds the menu out of <details>, which
   is a CLICK control by definition, and details-disclosure.js only adds
   focus/animation behaviour on top. CSS cannot help here: a closed <details>
   hides its content through the UA stylesheet's ::details-content slot, and
   overriding that is inconsistent across engines. So hover is driven here, by
   toggling the `open` attribute the element already understands.

   Both levels are covered - the top-level menus and the nested ones inside
   them (BASIC, חולצות נשים, מגפים ומגפונים, ...) - because the snippet uses
   <details> for both.

   Deliberately does NOT touch click. <summary> responds to Enter and Space by
   dispatching a click, so suppressing it to keep a hovered menu open would
   take the keyboard path with it. Hover opens, click still toggles, and both
   keep working. */
(function () {
  /* Hover only, and only where the dropdown menu is actually shown. On a
     touch device `mouseenter` fires on tap and would open a menu the shopper
     is trying to navigate past; below the desktop breakpoint the theme uses
     the drawer menu instead. */
  const HOVER_QUERY = '(hover: hover) and (min-width: 990px)';

  /* Small grace period on the way out. Menus and their submenus do not always
     share an edge, and a diagonal mouse path across a 1-2px gap would
     otherwise snap the menu shut mid-movement. */
  const CLOSE_DELAY = 140;

  const media = window.matchMedia(HOVER_QUERY);

  function summaryOf(details) {
    return details.querySelector(':scope > summary');
  }

  function setOpen(details, open) {
    if (!details) return;
    if (open) {
      details.setAttribute('open', '');
    } else {
      details.removeAttribute('open');
      /* Closing a parent leaves its children open otherwise, so the next
         hover would reveal a submenu already expanded from last time. */
      details.querySelectorAll('details[open]').forEach((child) => {
        child.removeAttribute('open');
        summaryOf(child)?.setAttribute('aria-expanded', 'false');
      });
    }
    summaryOf(details)?.setAttribute('aria-expanded', String(open));
  }

  function bind(details, nav) {
    if (details.dataset.hoverBound === 'true') return;
    details.dataset.hoverBound = 'true';

    let timer = null;

    details.addEventListener('mouseenter', () => {
      /* Checked at event time, not at bind time: the listener stays attached
         across a resize, and a window dragged below the breakpoint should stop
         opening menus on hover without needing to rebind anything. */
      if (!media.matches) return;
      window.clearTimeout(timer);

      /* Only one top-level menu at a time. Without this, the 140ms grace
         period above lets the menu being left overlap the one being entered. */
      if (details.closest('details') === details) {
        nav.querySelectorAll('details[open]').forEach((other) => {
          if (other !== details && !other.contains(details)) setOpen(other, false);
        });
      }

      setOpen(details, true);
    });

    details.addEventListener('mouseleave', () => {
      if (!media.matches) return;
      window.clearTimeout(timer);
      timer = window.setTimeout(() => setOpen(details, false), CLOSE_DELAY);
    });
  }

  function init() {
    const nav = document.querySelector('.header__inline-menu');
    if (!nav) return;

    const bindAll = () => nav.querySelectorAll('details').forEach((d) => bind(d, nav));
    bindAll();

    media.addEventListener('change', (event) => {
      if (event.matches) {
        bindAll();
      } else {
        /* Leaving hover territory - a menu left open by a hover would
           otherwise stay expanded in the layout that does not expect it. */
        nav.querySelectorAll('details[open]').forEach((d) => setOpen(d, false));
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
